<template>
    <div class="match-body" id="home-match-body">
        <div class="side-panel-icon" id="hot-panel-icon" :class="{ 'spin': selected_panel == 'hot', 'open': selected_panel != '' }" @click="panelClick('hot')">
            <span class="icon-symbol">⚽</span>
        </div>
        <div class="side-panel-icon earth-panel-icon" id="earth-panel-icon" :class="{ 'spin': selected_panel == 'earth', 'open': selected_panel != '' }" @click="panelClick('earth')">
            <span class="icon-symbol">🌐</span>
        </div>
        <div class="side-panel-overlay" :class="{ 'open': selected_panel != '' }" id="side-panel-overlay" @click="panelClick()"></div>
        <div class="side-box-container left">
            <div class="side-box hot-box" :class="{ collapsed: collapsedBoxes.includes(0)&&innerWidth>1132, 'open': selected_panel == 'hot' }" id="hot-panel-wrapper">
                <div class="form-header" @click="toggleCollapse(0)">
                    <div class="form-title-text">{{ arr_lang.home['HOME.HOT_MATCH'] }}</div>
                    <button class="form-toggle-btn">
                        <svg class="toggle-arrow" viewBox="0 0 24 24">
                            <path d="M6 9l6 6 6-6" stroke-width="2" fill="none"></path>
                        </svg>
                    </button>
                    <div class="panel-close" id="panel-close" @click="panelClick()">
                        <svg viewBox="0 0 24 24">
                            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 0 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"></path>
                        </svg>
                    </div>
                </div>
                <div class="form-body">
                    <template v-for="value in hotMatchList['events']">
                        <div class="form-item" @click="filterLeague(value, true)" :class="checkHotLeg(value, selected_league)">
                            <div class="form-item-icon" v-if="(account.showCtrLogo && value.ctrlogo) || (account.showLogo && value.lglogo)">
                                <img class="" :src="account.showCtrLogo && value.ctrlogo ? value.ctrlogo : value.lglogo">
                            </div>
                            <div class="form-item-text" :title="value.league"><a :class="checkHotLeg(value, selected_league)">{{ value.league }}</a></div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="side-box schedule-box">
                <div class="form-header">
                    <div class="form-title-text">{{ arr_lang.home['HOME.SCHEDULE'] }}</div>
                </div>
                <div class="form-body schedule-body">
                    <div class="form-item schedule-box-tabs">
                        <button id="tab-completed" :class="{ active: scheduleTab === 'completed' }" @click="toggleScheduleTab('completed')">{{ arr_lang.home['HOME.COMPLETED_SCHEDULE'] }}</button>
                        <button id="tab-upcoming" :class="{ active: scheduleTab === 'upcoming' }" @click="toggleScheduleTab('upcoming')">{{ arr_lang.home['HOME.NEXT_SCHEDULE'] }}</button>
                    </div>
                    <div id="content-completed" v-show="scheduleTab === 'completed'">
                        <div class="form-item" v-for="(date, key) in completedDateList" :key="key" @click="changeDate(schedule,date)" :class="selected_date == date ? 'current' : ''">
                            <div class="form-item-text"><a :class="selected_date == date ? 'current' : ''" class="notranslate">{{ date | date('YYYY-MM-DD') }}</a></div>
                        </div>
                    </div>
                    <div id="content-upcoming"  v-show="scheduleTab === 'upcoming'">
                        <div class="form-item" v-for="(date, key) in arr_earlyParlayDateList" :key="key" v-if="key!=0" @click="changeDate(schedule,date)" :class="selected_date == date ? 'current' : ''">
                            <div class="form-item-text"><a :class="selected_date == date ? 'current' : ''"  class="notranslate">{{ date | date('YYYY-MM-DD') }}</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
        
        <div class="match-body-content">
            <gameBanner :position="'t'"></gameBanner>
            <div class="filter-box">
                <div class="event-title">
                    {{ sportTableLang['SPORT_TABLE.'+selectedSport+'_MATCHES']? sportTableLang['SPORT_TABLE.'+selectedSport+'_MATCHES']:(selectedSport+' '+sportTableLang['SPORT_TABLE.SUBHEADER_MATCHES1']) }}
                </div>
                <div class="event-controls">
                    <div id="timezoneToggle" class="timezone-selector" :class="{ 'open': isTimeZoneOpen }" @click="toggleTimezone">
                        <div class="timezone-left">
                            <div class="timezone-icon"></div>
                            <span class="selected-timezone notranslate">{{ getSelectedTz }}</span> <!--arr_lang.home['HOME.TIMEZONE']-->
                        </div>
                        <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke-width="2">
                            <polyline points="6 9 12 15 18 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></polyline>
                        </svg>
                        <div class="timezone-dropdown">
                            <div class="option notranslate" v-for="(val, key) in timezonelist" :key="key" @click="changeTimezone(val)">{{ key }}</div>
                        </div>
                    </div>
                    <div class="date-selector">
                        <div class="date-icon"></div>
                        <input type="date" id="customDateInput" :value="selected_date" @change="handleDateChange">
                    </div>
                    <div class="odds-switch-wrapper">
                        <span class="odds-label">{{ arr_lang.oddsConversionLang['ODDS_CONVERSION.ODDS'] }}</span>
                        <div id="oddsSwitch" class="odds-toggle" :class="{ 'active': showOdds }" @click="oddsSwitch">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
            </div>
            <contentSport :is-odds-switch="showOdds"></contentSport>
        </div>
       
        <div class="side-box-container right">
            <div class="live-hot-box">
                <div>
                    <div class="live-title">{{ arr_lang.home['HOME.HOT_LIVE_MATCH'] }}</div>
                    <div class="live-subtitle" :title="firstEvent && firstEvent.lgecapt ? firstEvent.lgecapt : ''" v-html="firstEvent && firstEvent.lgecapt ? firstEvent.lgecapt : '-'"></div>
                </div>

                <div class="live-teams">
                    <div class="live-team">
                        <div class="team-icon-circle">
                            <div class="team-icon">
                                <img :src="firstEvent.talogo" v-if="firstEvent && firstEvent.talogo"></img>
                                <img src="assets/images/team_icon/team_icon_default01.png" v-else-if="skinTheme==1"></img>
                                <img src="assets/images/team_icon/team_icon_default02.png" v-else></img>
                                <!-- <img src="https://img.icons8.com/?size=100&id=66773&format=png&color=BFBFBF" v-else></img> -->
                            </div>
                        </div>
                        <div class="team-name" :title="firstEvent && firstEvent.tacapt ? firstEvent.tacapt : ''" v-html="firstEvent && firstEvent.tacapt ? firstEvent.tacapt : '-'"></div>
                    </div>

                    <div class="live-score" :style="firstEvent && firstEvent.sptid == 2? 'font-size: 27px !important;':''">
                        <!-- <template v-if="firstEvent && firstEvent.rbinfo">{{ firstEvent.rbinfo.scoa }} - {{ firstEvent.rbinfo.scob }}</template> -->
                        <template v-if="firstEvent && firstEvent.score && firstEvent.score.FT">{{ firstEvent.score.FT }}</template>
                        <template v-else-if="firstEvent && firstEvent.score && firstEvent.score.HT">{{ firstEvent.score.HT }}</template>
                        <template v-else>0 - 0</template>
                    </div>

                    <div class="live-team">
                        <div class="team-icon-circle">
                            <div class="team-icon">
                                <img :src="firstEvent.tblogo" v-if="firstEvent && firstEvent.tblogo"></img>
                                <img src="assets/images/team_icon/team_icon_default01.png" v-else-if="skinTheme==1"></img>
                                <img src="assets/images/team_icon/team_icon_default02.png" v-else></img>
                                <!-- <img src="https://img.icons8.com/?size=100&id=66773&format=png&color=BFBFBF" v-else></img> -->
                            </div>
                        </div>
                        <div class="team-name" :title="firstEvent && firstEvent.tbcapt ? firstEvent.tbcapt : ''" v-html="firstEvent && firstEvent.tbcapt ? firstEvent.tbcapt : '-'"></div>
                    </div>
                </div>

                <template v-if="firstEvent && Object.keys(firstEvent).length">
                    <!-- <simpleSoccer1x2 :event="firstEvent" :plytyp="getPlaytype()" :bettyp="getBettype(firstEvent.sptid,firstEvent.rbstatus)" :odds-title="true"></simpleSoccer1x2> -->
                    <odds1x2 :event="firstEvent" :bmk="'8'" :plytyp="(firstEvent.rb == 1? '3':'2')" :bettyp="'5'" :type="'2'"></odds1x2>
                </template>
                <template v-else>
                    <div class="odds-row">
                        <div class="odds-box">
                            <span class="odds-number">1</span>
                            <span class="odds-value">-</span>
                        </div>
                        <div class="odds-box" v-if="arr_selectedTemplate.sportId == 'N1'">
                            <span class="odds-number">x</span>
                            <span class="odds-value">-</span>
                        </div>
                        <div class="odds-box">
                            <span class="odds-number">2</span>
                            <span class="odds-value">-</span>
                        </div>
                    </div>
                </template>

                <div class="live-buttons">
                    <div class="btn btn-red" @click="getAllBet(firstEvent,1)"></div> <!--  :class="{ 'disable':(!firstEvent || (firstEvent && Object.keys(firstEvent).length && (firstEvent.rb != 1 || firstEvent.ch == undefined || firstEvent.ch == 0))) }" -->
                    <div class="btn btn-blue" @click="getAllBet(firstEvent,0)">
                        <span>{{ arr_lang.home['HOME.MATCH_DETAILS'] }}</span>
                    </div>
                    <div class="btn btn-grey" id="star-btn" @click.stop="favourite(firstEvent)" :class="{ 'active': firstEvent && firstEvent.isFavourite? firstEvent.isFavourite:false }"></div>
                </div>
            </div>
            
            <div class="side-box country-box" :class="{ collapsed: collapsedBoxes.includes(1), 'open': selected_panel == 'earth' }" id="earth-panel-wrapper">
                <div class="form-header" @click="toggleCollapse(1)">
                    <div class="form-title-text">{{ arr_lang.home['HOME.COUNTRY_MATCH'] }}</div>
                    <button class="form-toggle-btn">
                        <svg class="toggle-arrow" viewBox="0 0 24 24">
                            <path d="M6 9l6 6 6-6" stroke-width="2" fill="none"></path>
                        </svg>
                    </button>
                    <div class="panel-close" id="panel-close" @click="panelClick()">
                        <svg viewBox="0 0 24 24">
                            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 0 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"></path>
                        </svg>
                    </div>
                </div>
                <div class="form-body">
                    <div class="form-item" v-for="(cty,key) in countryMatches" @click="selectCountry(cty.cid)" :class="selected_country == cty.cid ? 'current' : ''">
                        <div class="form-item-icon" :class="'nation-icon-'+cty.icon"></div>
                        <div class="form-item-text" :title="cookies_lang == 'zh_CN'? cty.name_2 : (cookies_lang == 'zh_TW'? cty.name_3 : cty.name_1)">
                            <a :class="selected_country == cty.cid ? 'current' : ''">{{ cookies_lang == 'zh_CN'? cty.name_2 : (cookies_lang == 'zh_TW'? cty.name_3 : cty.name_1) }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>   
    </div>
</template>
<script>
import {
    mapGetters
  } from 'vuex'

import EventBus from '@/vue/events/event-bus'
import moment from 'moment'
import marketHeader from './marketHeader.vue'
import contentSport from './contentSport.vue'
import loadingScreen from '@/vue/components/loadingScreen'
import gameBanner from '../home/gameBanner'
// import simpleSoccer1x2 from './oddsTable/simpleSoccer-1x2'
import odds1x2 from './oddsTable/odds1x2'
import sportFavourite from '@/vue/mixins/favourite'

  export default {
      mixins: [sportFavourite],
      computed: {
        ...mapGetters([
            'arr_selectedTemplate',
            'arr_selectedLeague',
            'sortTypes',
            'sportTableLang',
            'arr_earlyParlayDateList',
            'int_selectedParlayDate',
            'selectedSort',
            'int_marketToggle',
            'bettingSelection',
            'bettingFormToggle',
            'arr_lang',
            'bettingMessage',
            'arr_sportList',
            'arr_selectedLeagues',
            'showCalendarBox',
            'selectedMatches',
            'isParlay',
            'isSpecial',
            'isCorrectScore',
            'arr_leagueList',
            'totalPage',
            'subLoading',
            'account',
            'fullLoading',
            'selectedState',
            'sportSelected',
            'isOtr',
            'showFavEvents',
            'skinTheme',
            'showFloating',
            'isShowBtModal',
            'isShowFilter',
            'showHelp',
            'emptyBetAmt',
            'combMaxInfo',
            'isComboBet',
            'haveEmptyCombo',
            'notSupportParlay',
            'isresult_schedule',
            'dateList',
            'selected_date',
            'schedule',
            'matchSchdTab',
            'arr_selectedLeagueList',
            'sortedEvents',
            'tvIconFlag',
            'selected_timezone',
            'selectedSport',
            'hotMatchList',
            'selected_country',
            'selected_league',
            'showOdds'
        ]),
        currentSport: function() {
            return this.$store.getters.sportBettypeList[this.arr_selectedTemplate.sportId]
        },
        selectedPage: {
            get () {
                return this.$store.getters.selectedPage
            },
            set (value) {

                this.reloadingPer='0%';
                this.reloading = true
                EventBus.$emit('refreshOdd', true)
                this.$store.commit('SELECTED_PAGE', value)
                this.reloadTable(token.arr_13+'|'+value)
            }
        },
        completedDateList: function() {
            return this.dateList && this.dateList.length? this.dateList.slice(0, 7):this.dateList;
        },
        firstEvent() {
            const events = this.$store.getters.sortedEvents;
            return events && events.length ? events[0] : null;
        },
        getSelectedTz() {
            var filtered = Object.values(this.timezonelist).filter(tz => tz.value == this.selected_timezone);
            return filtered.length > 0 ? filtered[0].caption : this.arr_lang.home['HOME.TIMEZONE'];
        },
      },
      components: {
        marketHeader,
        contentSport,
        loadingScreen,
        gameBanner,
        // simpleSoccer1x2,
        odds1x2,
      },
      data(){
          return{
                timerSeconds: 90,
                timerId: null,
                selectedSortType: "",
                selectedDate: "",
                token: window.token,
                cookies_lang: window._cookie,
                gameBannerImage: window._gameBannerImage,
                heightPX : window.innerHeight,
                popularLeagues: window.popularLeagues,
                countryMatches: window.countryMatches,
                timezonelist: window._timezonelist,
                collapsedBoxes: [],
                scheduleTab: 'completed',
                isTimeZoneOpen: false,
                ftPlyType: '1',
                setHandicapPlyType: '3',
                onex2BetType: '4',
                ronex2BetType: '11',        
                mlBetType: '12',
                rmlBetType: '13',
                selected_panel: '',
                innerWidth: window.innerWidth,
          }
      },
      methods: {
        getWeekdays(dt){
            if(this.cookies_lang == 'en_US'){
                return moment(dt).format('ddd')
            }else{
                return moment(dt).format('dddd')
            }
        },
        getMonth(dt){
            if(this.cookies_lang == 'en_US'){
                return moment(dt).format('MMM')
            }else{
                return moment(dt).format('MMMM')
            }
        },
        changeEarlyParlayDate(datekey){
            this.$store.commit('SELECTED_PAYLAY_DATE', datekey)
            this.$store.dispatch('getLaugueList', {
                token: token.arr_6
            })
        },
        startTimer() {
            if(this.int_marketToggle == 3){
                this.timerSeconds = 10
            }
            if(this.timerId == null){
                this.timerId = setInterval(() => {
                    if(!this.bettingFormToggle){
                        if(!this.bettingMessage){
                            if(this.timerSeconds - 1 < 0) {
                                this.reloadTable(token.arr_1)
                            } else {
                                this.timerSeconds -= 1;
                            }
                        }
                    }
                },1000);
            }
        },
        refreshTimer () {
            this.clearTimer()
            this.timerSeconds = 90
            if(this.int_marketToggle == 3){
                this.timerSeconds = 10
            }
            this.startTimer()
        },
        clearTimer() {
            clearInterval(this.timerId)
            this.timerId = null
        },
        reloadTable(token_val=null){
            
            // if(this.arr_selectedTemplate.templateId == '2'){
            //     if(this.arr_selectedTemplate.subTemplateId == '3'){
            //         this.$store.dispatch('getOutrightLeague', { token: token_val })
            //     }else{
            //         if(this.int_marketToggle==3){
            //             this.$store.dispatch('getLiveSportOdds', {
            //                 loading: 1,
            //                 token: token_val,
            //             })
            //         }
            //     }
            // }else if(this.arr_selectedTemplate.templateId == '6'){
            //     this.$store.dispatch('getSportAllBet', {
            //         event: this.$store.getters.arr_selectedEvent,
            //         loading: '1',
            //         token: token_val,
            //     })
            // }else if(this.arr_selectedTemplate.templateId == '19'){
            //     this.$store.dispatch('getSportOdds', {
            //         loading: 1,
            //         isResult: true,
            //         token: token.arr_2,
            //     })
            // }else{
            //     if(this.arr_selectedTemplate.subTemplateId == '3'){
            //         this.$store.dispatch('getSportOutrightOdds', { token: token_val })
            //     }else{
            //         if(this.arr_selectedTemplate.subTemplateId == '4'){
            //             if(this.$store.getters.isSpecial){
            //                 this.$store.dispatch('getSpecialCorrectScore', {    //euro
            //                     loading: 1,
            //                     token: token_val,
            //                 })
            //             } else {
            //                 this.$store.dispatch('getSportCorrectScore', { //getSportCorrectScore
            //                     loading: 1,
            //                     token: token_val,
            //                     state: (this.selectedState)?this.selectedState:'',
            //                 })
            //             }

                        
            //         } else {
            //             if(this.$store.getters.isSpecial){
            //                 this.$store.dispatch('getSpecialEventOdds', {
            //                     loading: 1,
            //                     token: token_val,
            //                 })
            //             } else {
            //                 if(this.$store.getters.int_marketToggle=='1'){
            //                     this.$store.dispatch('getTodayRBSportOdds', {
            //                         loading: 1,
            //                         token: token_val,
            //                         isGameBanner: 0,
            //                         state: (this.selectedState)?this.selectedState:'',
            //                     })
            //                 } else {
            //                     if(this.int_marketToggle == '3'){
            //                         this.$store.dispatch('getLiveSportOdds', {
            //                         loading: 1,
            //                         token: token_val,
            //                         })
            //                     }else{
            //                         this.$store.dispatch('getSportOdds', {
            //                             loading: 1,
            //                             token: token_val,
            //                             isGameBanner: 0,
            //                             state: (this.selectedState)?this.selectedState:'',
            //                         })
            //                     }
            //                 }
            //             }
            //         }
            //     }
                
            // }
            this.$store.dispatch('getSportOdds', {
                loading: 0,
                token: token_val,
            })
            this.refreshTimer()
        },
        changeSubTemplate(subTemplateId, sportId = null){
            if(((this.$store.getters.int_marketToggle == '1' || this.$store.getters.int_marketToggle == '2' ) && subTemplateId == 2)
                || (this.$store.getters.int_marketToggle == '2' && subTemplateId == 1)) {
                    this.$store.commit('SELECTED_PAYLAY_DATE', 99)
                if(this.$store.getters.int_marketToggle == '1' && subTemplateId == 2) {
                    this.$store.commit('SELECTED_PAYLAY_DATE', 0)
                }
                this.selectedDate = this.int_selectedParlayDate
            }

            if((account.previewFlag==undefined) || (account.previewFlag && this.$store.getters.int_marketToggle!='1')){//(account.previewFlag==undefined && market!='3') ||
                var btemplateId = 2;
            } else if ((account.previewFlag && this.$store.getters.int_marketToggle=='1')){ //|| (account.previewFlag==undefined && market=='3')
              var btemplateId = 3;
              this.$store.commit('SEL_MATCH', true)
            } 
            
            this.$store.dispatch('changeTemplate', {
                templateId: btemplateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 1,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: sportId != null ? sportId : this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId,
            })
            if(subTemplateId == '3'){
                this.$store.dispatch('getOutrightLeague', {
                    token: token.arr_2,
                })
            }else{
                if(this.$store.getters.int_marketToggle == '3'){
                    this.$store.dispatch('getLiveSportOdds', {
                        enableLoading:true,
                        token: token.arr_2,
                    })
                }else{
                    //this.$store.commit('SUBLOAD', true)
                    if(this.$store.getters.isSpecial)
                    {
                        this.$store.dispatch('getSpecialEventOdds', {
                            enableLoading:true,
                            token: token.arr_2,
                        })
                    }
                    else
                    {
                        if(this.isOtr){
                            this.$store.dispatch('getOutrightLeague', { token: token.arr_1 })
                        }else{
                            if(this.$store.getters.arr_selectedTemplate.marketKey==1){
                                this.$store.dispatch('getTodayRBSportOdds', {
                                    loading: 1,
                                    token: token.arr_2,
                                    state: (this.$store.getters.selectedState)?this.$store.getters.selectedState:'',
                                })
                            } else {
                                this.$store.dispatch('getSportOdds', {
                                    loading: 1,
                                    token: token.arr_2,
                                    state: (this.$store.getters.selectedState)?this.$store.getters.selectedState:'',
                                })
                            }
                        }
                    }
                }
            }
            this.refreshTimer()
        },
        changeSpecialTemplate(market){
            var sprtId = 'N1'
            var plytype = 1
            var subTemplateId = 1

            var bettypeid = sprtId.split('')
            if(bettypeid.length >= 3){
                bettypeid = bettypeid[1]+""+bettypeid[2]
            }else{
                bettypeid = bettypeid[1]
            }
            this.$store.commit('SUBLOAD', true)
            // EventBus.$emit('marketChange', market)
            this.$store.commit('ARR_LEAGUES', [])
            this.$store.commit('SELECTED_LEAGUES', [])
            this.$store.commit('SEL_MATCH', false)
            this.$store.commit('SELECTED_LEAGUE', [])
            this.$store.commit('SORTEDEVENTLIST', [])
            
            this.$store.commit('S_ODD', true)

            this.$store.dispatch('getEventList', {
                market: market,
                token: token.arr_2,
                callback: ((res) => {
                    this.$store.commit('MARKETTOGGLE', market)						
                    this.$store.dispatch('changeTemplate', {
                        templateId: 2, //4
                        marketKey: market,
                        plytype: plytype,
                        bettypeid: bettypeid,
                        sportId: sprtId,
                        subTemplateId: subTemplateId,
                    })
                    this.$store.commit('SELECTED_MARKET', market)
                    //     this.$store.commit('SUBLOAD', false)
                    EventBus.$emit('sportTemplate', sprtId)
                    $('.chkbox_league').prop('checked', false)
                }).bind(this)
            })
        },
        sortLeague(event, token_val=null){
            // this.$store.commit('S_ODD', true)
            var sortId = this.selectedSort == '1' ? '2' : '1'
            this.$store.commit('SELECTED_SORT', sortId)
            this.reloadTable(token_val)
        },
        sportTemplate(sportId){
            let vue = this
            
            this.$store.commit('SELECTED_TEMPLATE', {
                sportId: sportId,
                marketKey: vue.int_marketToggle,
                subTemplateId: vue.$store.getters.arr_selectedTemplate.subTemplateId
            })
            
            this.$store.commit('SELECTED_SPORT', sportId)
            var bettypeid = sportId.split('')
            if(bettypeid.length >= 3){
                bettypeid = bettypeid[1]+""+bettypeid[2]
            }else{
                bettypeid = bettypeid[1]
            }
            EventBus.$emit('enableLoading',true)
            this.changeSubTemplate(vue.$store.getters.arr_selectedTemplate.subTemplateId, sportId)
            this.$store.commit('SELECTED_MARKET', this.int_marketToggle)
        },
        goBack () {
            if(this.$store.getters.isSpecial){
                if(this.$store.getters.arr_selectedTemplate.templateId == 6) {
                    this.changeSpecialTemplate(this.$store.getters.int_marketToggle)
                }else{
                    this.changeSpecialTemplate(1)
                }
            }else{
                this.$store.commit('ARR_LEAGUES', [])
                this.$store.commit('SEL_MATCH', false)
                this.$store.commit('SORTEDEVENTLIST', [])
                if(this.$store.getters.arr_selectedTemplate.templateId==17){
                    this.changeTemplate(1)
                }else if(this.$store.getters.arr_breadcumb.length > 0) {
                    if(this.$store.getters.arr_selectedTemplate.templateId == 3){
                        this.$store.commit('SELECTED_LEAGUE', [])
                        this.$store.commit('SELECTED_LEAGUES', [])
                        this.$store.commit('SELECTED_STATE', '')
                        if(this.isParlay){
                            this.$store.dispatch('changeTemplate', {
                                templateId: 21,
                                marketKey: this.$store.getters.int_marketToggle,
                                plytype: 1,
                                bettypeid: this.arr_selectedTemplate.bettypeid,
                                sportId: this.arr_selectedTemplate.sportId,
                                subTemplateId: 2,
                            })
                        }else{
                            this.$store.dispatch('changeTemplate', {
                                templateId: 2,
                                marketKey: this.$store.getters.int_marketToggle,
                                plytype: 1,
                                bettypeid: this.arr_selectedTemplate.bettypeid,
                                sportId: this.arr_selectedTemplate.sportId,
                                subTemplateId: 1,
                            })
                        }
                        
                    }else{
                        this.$store.dispatch('redirectReturn')
                    }
                }else if(this.$store.getters.arr_selectedTemplate.subTemplateId != 4) {
                    this.$store.commit('SELECTED_LEAGUE', [])
                }else if(this.$store.getters.arr_selectedTemplate.templateId != 6) {
                    this.$store.commit('SELECTED_LEAGUES', [])
                }else{
                    window.history.go(-1)
                }
            }
        },
        showCalendar(){
            if(this.$store.getters.showCalendarBox){
                this.$store.commit('SHOW_CALENDAR', false)
            }else{
                this.$store.commit('SHOW_CALENDAR', true)
            }
        },
        getMainMarket(subTemplateId, token_val=null){
            // this.$store.commit('S_ODD', true)
            this.$store.commit('IS_CORRECTSCORE', false)
            var templateId = this.$store.getters.int_marketToggle == '3' ? 2 : 3

            if(this.$store.getters.int_marketToggle == '3'){
                this.$store.commit('SELECTED_LEAGUES', [])
            }

            if(this.selectedState != null && this.selectedState != ''){
                this.$store.commit('SELECTED_LEAGUE', [])
            }

            var plytype = 1

            if(this.isParlay){
                plytype = 5
                subTemplateId = '2'
            }

            this.$store.dispatch('changeTemplate', {
                templateId: templateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: plytype,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId,
            })
        },
        getCorrectScore(subTemplateId, token_val=null){
            // this.$store.commit('S_ODD', true)
            var market = this.$store.getters.isParlay ? 1 : this.$store.getters.int_marketToggle
            this.$store.commit('MARKETTOGGLE',market) //fix parlay cs change oddtype 
            this.$store.commit('IS_CORRECTSCORE', true)
            
            var templateId = this.$store.getters.int_marketToggle == '3' ? 2 : 3
            if(this.$store.getters.isSpecial){
                templateId = 2
            }
            this.$store.dispatch('changeTemplate', {
                templateId: templateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 2, //1
                bettypeid: 7,
                sportId: this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId,
            })
            
            this.$store.commit('SUBLOAD', true)
            if(this.$store.getters.isSpecial){
                this.$store.dispatch('getSpecialCorrectScore', { //getSportCorrectScore
                    loading: 1,
                    token: token_val,
                })
            } else {
                this.$store.dispatch('getSportCorrectScore', { //getSportCorrectScore
                    loading: 1,
                    token: token_val,
                    state: (this.selectedState)?this.selectedState:''
                })
            }
            
        },
        getLiveLeague(token_val=null) {
            this.$store.dispatch('changeTemplate', {
                templateId: 2,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 1,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: this.arr_selectedTemplate.sportId,
                subTemplateId: 5,
            })
                    this.$store.dispatch('getLaugueList', {
                        enableLoading:true,
                        token: token.arr_2,
                    })
            this.refreshTimer()
        },
        toggleActive(){
            this.sortActive = false
            this.showTypeActive = false
            this.oddsTypeActive = false
            this.marketActive = false
        },
        checkSportList(sport) {
            let STORE = this
            var sportId = []
            if(sport == 'N1'){
                sportId = ['1']
            }else if(sport == 'G1'){
                sportId = ['2', '13']
            }else if(sport == 'N3'){
                sportId = ['3']
            }else if(sport == 'N21'){
                sportId = ['21']
            }else if(sport == 'N12'){
                sportId = ['12']
            }else if(sport == 'N24'){
                sportId = ['24']
            }else if(sport == 'N23'){
                sportId = ['23']
            }else if(sport == 'N15'){
                sportId = ['15']
            }else if(sport == 'G2'){
                sportId = ['7', '14', '19', '20']
            }else if(sport == 'G98'){
                sportId = ['1', '2', '3', '7', '12', '13', '14', '15', '19', '20', '21', '23', '24']
            }

            var d = _.keys(this.arr_sportList)
            _.each(sportId, function(val){
                if(_.includes(d, val)){
                    STORE.$set(STORE.$store.getters.arr_selectedTemplate, 'sportId', sport)
                    STORE.$store.commit('SPORT_SELECTED', true)
                }else{
                    STORE.$store.commit('SPORT_SELECTED', false)
                }
            })
        },
        getAllSportCount(comid){
            // 60 sec to get once
            var Vue = this

            Vue.$store.dispatch('getSportCount');
            Vue.$store.dispatch('getSportCountByMarket');

            setInterval(function(){
                Vue.$store.dispatch('getSportCount');
                Vue.$store.dispatch('getSportCountByMarket');
            }, 60000)
        },
        changeMarket(val, dt) { //val - 1: all(live,today,result), 2: live, 3: result, 4: today, 5: early
            if(dt == undefined) {
                let date = new moment().utcOffset(this.$store.getters.selected_timezone).format("YYYY-MM-DD");
                dt = date // window.earlyDateList[0]
            }
            $( ".scroll" ).scrollTop( 0 );

            // this.$store.dispatch('changeTemplate',{templateId:1})
            // this.$store.commit('SELECTED_TEMPLATE', {templateId:1})
            this.$store.commit('SORTEDEVENTLIST', [])
            this.$store.commit('MATCH_SCHEDULE_TAB', val);
            this.$store.commit('SCHEDULE', val);
            if(this.$store.getters.selected_country){
                this.$store.commit('PLAYTYPE', 3)
            }
            // this.$store.commit('PLAYTYPE', 1);
            // this.$store.commit('MARKETTOGGLE', market);
            // this.$store.commit('LEAGUE_LIST',{})
            // this.$store.commit('PLY_TYPE',{})

            if(val == 3) { // result
                this.$store.commit('SELECTEDDATE',dt)
            } else {
                this.$store.commit('SELECTEDDATE',dt)
            }
            this.$store.dispatch('getSportOdds', {
                loading: 1,
                token: token.arr_2,
            })

        },
        changeDate(val,dt) {
            if (this.$store.getters.selected_league == null) {
                this.$store.commit('PLAYTYPE', 1);
            }
            if(this.scheduleTab == 'completed'){
                val = 3
            }else if(this.scheduleTab == 'upcoming'){
                val = 1
            }
            this.changeMarket(val,dt)
        },
        checkHotLeg(lge, selected){
            if(lge.lgeid == selected){
                return 'current'
            }
        },
        filterLeague(lge, isHot = false) {
            $( ".scroll" ).scrollTop( 0 );
            var plytyp = 2
            var sport = lge.sptid
            var lgeid = lge.lgeid
            var getSport = _.filter(this.$store.getters.titleSport, function(x){
                return _.includes(x.sid, sport.toString())
            })
            if(getSport && getSport.length > 0) {
                sport = getSport[0].id
            }
            if(lgeid == this.selected_league) {
                lgeid = null
                plytyp = 1
            }
            if (isHot) {
                EventBus.$emit('changeMatches')
            }
            this.$store.commit('SELECTEDCOUNTRY', null)
            this.$store.commit('SELECTED_SPORT', sport)
            this.$store.commit('SELECTEDLEAGUE', lgeid)
            this.$store.commit('SELECTED_TEMPLATE', {templateId:1})
            this.$store.commit('PLAYTYPE', plytyp);
            this.changeMarket(this.$store.getters.schedule, this.$store.getters.selected_date)
        },
        toggleCollapse(index) {
            if(window.innerWidth < 769) {
                this.collapsedBoxes = []
                return
            }
            const idx = this.collapsedBoxes.indexOf(index);
            if (idx > -1) {
            this.collapsedBoxes.splice(idx, 1);
            } else {
            this.collapsedBoxes.push(index);
            }
        },
        toggleScheduleTab(tab) {
            this.scheduleTab = tab;
        },
        toggleTimezone() {
            this.isTimeZoneOpen = !this.isTimeZoneOpen;
        },
        changeTimezone(val) {
            $('.selected-timezone').text(val.caption)
            this.$store.commit('SELECTEDTIMEZONE', val.value)
            this.reloadTable()
        },
        oddsSwitch() {
            this.$store.commit('SHOW_ODDS_TOGGLE', !this.showOdds)
            this.$ajax({
              url: _baseUrl + '/account-def-settings',
              type: 'get',
              data: {
                action: 'previewSetting',
                showOdds: this.showOdds? 1:0
              }
            }).done(response => {})
        },
        getAllBet(event,channel=0) {
            if(event && Object.keys(event).length) {
                if(channel == 1 && (event.rb != 1 || event.ch == 0)){
                    EventBus.$emit('getAllBet',event,0)
                }else{
                    EventBus.$emit('getAllBet',event,channel)
                }
            }
        },
        getPlaytype() {
            if(this.arr_selectedTemplate['sportId'] == 'N3' || this.arr_selectedTemplate['sportId'] == 'N21'  || this.arr_selectedTemplate['sportId'] == 'N12') {
                return this.setHandicapPlyType
            }else {
                return this.ftPlyType
            }
        },
        getBettype(spid, rb){
            if(spid==1){
                if(rb==1){
                    return this.ronex2BetType
                }else{
                    return this.onex2BetType
                }
            }else{
                if(rb==1){
                    return this.rmlBetType
                }else{
                    return this.mlBetType
                }
            }
        },
        selectCountry(cid) {
            var plytyp = 3
            if(cid == this.selected_country) {
                cid = null
                plytyp = 1
            }
            $( ".scroll" ).scrollTop( 0 );
            // this.$store.commit('SELECTED_SPORT', sportId)
            this.$store.commit('SELECTEDLEAGUE', null)
            this.$store.commit('SELECTEDCOUNTRY', cid)
            this.$store.commit('SELECTED_TEMPLATE', {templateId:1})
            this.$store.commit('PLAYTYPE', plytyp);
            EventBus.$emit('changeMatches');
            this.changeMarket(this.$store.getters.schedule, this.$store.getters.selected_date)
        },
        handleDateChange(event) {
            // console.log('New date:', event.target.value)
            if (this.$store.getters.selected_league == null) {
                this.$store.commit('PLAYTYPE', 1);
            }
            this.changeMarket(this.$store.getters.schedule, event.target.value)
        },
        panelClick(panel = '') {
            this.selected_panel = panel
        },
        handleResize() {
            this.innerWidth = window.innerWidth;
            if(window.innerWidth < 769) {
                this.collapsedBoxes = []
            } else {
                this.panelClick()
            }
        }
      },
      beforeMount: function(){
        if(!this.isParlay){
            this.$store.commit('SELECTED_PAYLAY_DATE', 99)
        }
        if(this.int_marketToggle == '1' && this.arr_selectedTemplate.subTemplateId == 2) {
            this.$store.commit('SELECTED_PAYLAY_DATE', 0)
        }
          
        this.selectedDate = this.int_selectedParlayDate
        this.selectedSortType = this.selectedSort

        this.startTimer()
        EventBus.$on('resetTimer', (function(){
            this.refreshTimer()
        }).bind(this))
        EventBus.$on('refreshSportHeaderSelection', (function(){
            this.selectedDate = this.int_selectedParlayDate
        }).bind(this))
        EventBus.$off('sportTemplate')
        EventBus.$on('sportTemplate', (function(sportId){
            this.sportTemplate(sportId)
        }).bind(this))
        EventBus.$off('sportOutrightTemplate')
        EventBus.$on('sportOutrightTemplate', (function(sportId){
            this.sportTemplate(sportId)
        }).bind(this))
        EventBus.$on('sportAllTemplate', (function(sportId){
            this.sportAllTemplate(sportId)
        }).bind(this))
        
        EventBus.$off('changeMarketTab')
        EventBus.$on('changeMarketTab', (function(val,dt){
            this.changeMarket(val,dt)
        }).bind(this))
        EventBus.$off('filterLeague')
        EventBus.$on('filterLeague', (function(val){
            this.filterLeague(val)
        }).bind(this))
      },
      destroyed(){
        EventBus.$off('changeMarketTab')
        EventBus.$off('refreshSportHeaderDate')
        EventBus.$off('resetTimer')
        EventBus.$off('sportAllTemplate')
        if(this.$store.getters.isresult_schedule){
            EventBus.$off('sportTemplate')
        }
        this.clearTimer()
      },
      mounted() {
        // this.getAllSportCount(this.account.comId)
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
      },
      beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
      },
  }
</script>
<style lang="scss">



</style>



// WEBPACK FOOTER //
// resources/score/vue/apps/sport/sportHeader.vue